import React, { useEffect, useRef } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import HowItWorks from "./components/HowItWorks";
import Footer from "./components/Footer";
import AnimatedBackground from "./components/AnimatedBackground";
import Contact from "./pages/Contact";
import About from "./pages/About";
import "./App.css";

const HomePage = () => {
  const sectionsRef = useRef({});

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const isContainer = entry.target.classList.contains("info-card");
            const delay = isContainer ? 150 : 0;
            setTimeout(() => {
              entry.target.classList.add("is-visible");
            }, delay);
          } else {
            entry.target.classList.remove("is-visible");
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -100px 0px" }
    );

    const observeElements = () => {
      const revealEls = document.querySelectorAll(".reveal-on-scroll");
      revealEls.forEach((el) => {
        el.classList.remove("is-visible");
        observer.observe(el);
        const rect = el.getBoundingClientRect();
        const isInViewport = rect.top < window.innerHeight && rect.bottom > 0;
        if (isInViewport) {
          const isContainer = el.classList.contains("info-card");
          const delay = isContainer ? 150 : 0;
          setTimeout(() => {
            el.classList.add("is-visible");
          }, delay);
        }
      });
    };

    observeElements();
    const timeoutId = setTimeout(observeElements, 200);

    return () => {
      clearTimeout(timeoutId);
      const revealEls = document.querySelectorAll(".reveal-on-scroll");
      revealEls.forEach((el) => observer.unobserve(el));
      observer.disconnect();
    };
  }, []);

  return (
    <>
      <AnimatedBackground />
      <div className="app">
        <div className="top-header">
          <div className="navbar-wrap">
            <Navbar />
          </div>
        </div>

        <header className="app-header">
          <div className="title-glow"></div>
          <div className="hero-brand">
            <div className="hero-logo-ring">
              <img
                src="./img/GenieShop_logo.png"
                alt="Genie Shop Logo"
                className="hero-logo"
              />
            </div>
            <h1 className="hero-slogan">
              Search smarter. Shop better.
              <br />
              Agentic Shopping for Store-fronts.
            </h1>
          </div>
        </header>

        <main className="main-content">
          <section
            id="app"
            className="section"
            ref={(el) => (sectionsRef.current.app = el)}
          >
            <div className="section-inner">
              <HowItWorks />

              <div id="merchant" className="merchant-section">
                <div className="merchant-container reveal-on-scroll">
                  <div className="info-card merchant-card">
                    <div className="merchant-card-header">
                      <img src="./img/icon-shoppers.svg" alt="Shoppers" className="merchant-card-icon" />
                      <h3 className="merchant-title">Shoppers</h3>
                    </div>
                    <p>
                      Online shoppers who like to shop from AI chatbots confidently
                    </p>
                    <ul className="shoppers-list">
                      <li>Chat-based product discovery with Genie</li>
                      <li>AI ranking &amp; comparison against your own criteria</li>
                      <li>Researched product summaries with sources</li>
                      <li>Cart &amp; checkout without leaving the chat</li>
                    </ul>
                  </div>
                </div>
                <div className="merchant-container reveal-on-scroll">
                  <div className="info-card merchant-card">
                    <div className="merchant-card-header">
                      <img src="./img/icon-merchants.svg" alt="Brands" className="merchant-card-icon" />
                      <h3 className="merchant-title">Brands</h3>
                    </div>
                    <p>Grow your sales on AI chatbots with GenieShop</p>
                    <ul className="merchants-list">
                      <li>Customer Convenience</li>
                      <li>Transparency &amp; Trust</li>
                      <li>Easy Integration</li>
                      <li>Collaborative Growth</li>
                    </ul>
                    <a
                      href="https://biznetai.consumergenie.net/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="merchant-card-link"
                    >
                      List your store via BizNetAI &rarr;
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/" element={<HomePage />} />
      </Routes>
    </Router>
  );
}

export default App;
